import _ from 'lodash';
import { FORM_CONTROL_VALIDATE_TYPES } from './Types';

const REGEX = {
  email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  onlyChars: /^[a-zA-Z]+$/,
  path1: /^(\/[A-Za-z0-9_-]+)+(\/[A-Z][A-z_]{0,101}\.(tsx))$/,
  path2: /^(\\[A-Za-z0-9_-]+)+(\\[A-Z][A-z_]{0,101}\.(tsx))$/,
  url: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  localesPath1: /^(\/[A-Za-z0-9_-]+)+(\/[A-Z][A-z_]{3,19}\.(js))$/,
  localesPath2: /^(\\[A-Za-z0-9_-]+)+(\\[A-Z][A-z_]{3,19}\.(js))$/,
  noAmpersandAndSlash: /^[0-9a-zA-Z_@.\-][^ &$/]{2,50}$/
};

export const RULES: Record<string, Function[]> = {
  'exampleValidation': [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.exampleValidation',
    valid: value.length > 1
  })],
  [FORM_CONTROL_VALIDATE_TYPES.email]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.email',
    valid: REGEX.email.test(value)

  })],
  [FORM_CONTROL_VALIDATE_TYPES.onlyChars]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.onlyChars',
    valid: REGEX.onlyChars.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.noPastTime]: [(value: Date | string | any) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.noPastTime',
    valid: (() => {
      if (!_.isDate(value) && _.isString(value)) {
        value = new Date(value);
      }

      if (!value?.start) {
        return value >= new Date().setHours(0, 0, 0, 0);
      } else {
        return value?.start >= new Date().setHours(0, 0, 0, 0);
      }
    })()
  })],
  [FORM_CONTROL_VALIDATE_TYPES.noPastTomorrow]: [(value: Date | string | any) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.noPastTomorrow',
    valid: (() => {
      if (!_.isDate(value) && _.isString(value)) {
        value = new Date(value);
      }

      if (!value?.start) {
        return value >= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
      } else {
        return value?.start >= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
      }
    })()
  })],
  [FORM_CONTROL_VALIDATE_TYPES.sentence]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.sentence',
    valid: /[A-Z].+[.?!]$/.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.colorRequired]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.colorRequired',
    valid: value !== 'rgba(0, 0, 0, 0)'
  })],
  /**
   * Max length rule
   */
  [FORM_CONTROL_VALIDATE_TYPES.maxTweetLength]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.maxTweetLength',
    valid: value.length <= 280
  })],
  [FORM_CONTROL_VALIDATE_TYPES.maxTextLength]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.maxTextLength',
    valid: value.length >= 1 && value.length <= 255
  })],
  [FORM_CONTROL_VALIDATE_TYPES.languageRequired]: [(value: any) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.languageRequired',
    valid: !_.isEmpty(value) && !_.isNull(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.path]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.path',
    valid: REGEX.path1.test(value) || REGEX.path2.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.url]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.url',
    valid: REGEX.url.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.localesPath]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.localesPath',
    valid: REGEX.localesPath1.test(value) || REGEX.localesPath2.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.noAmpersandAndSlash]: [(value: string) => ({
    'data-commonnamespace': true,
    'data-error': 'validationErrorMessages.noAmpersandAndSlash',
    valid: REGEX.noAmpersandAndSlash.test(value)
  })],
  [FORM_CONTROL_VALIDATE_TYPES.maxCharactersLength]: [(value: string, additionalRulesConfig:{}) => {
    const maxCharactersLength = additionalRulesConfig['maxCharactersLength'] ? additionalRulesConfig['maxCharactersLength'] : 10;
    const minCharactersLength = additionalRulesConfig['minCharactersLength'] ? additionalRulesConfig['minCharactersLength'] : 0;
    if (!additionalRulesConfig['errorText']) {
      additionalRulesConfig['errorText'] = `This field can have a maximum of ${maxCharactersLength} characters`;
    }
    return {
      'data-commonnamespace': true,
      'data-error': 'validationErrorMessages.maxCharactersLength',
      'placeholders': additionalRulesConfig,
      valid: value.length <= maxCharactersLength && value.length >= minCharactersLength
    };
  }]
};

export const extendFormControlExistingRule = (ruleType: FORM_CONTROL_VALIDATE_TYPES, options: any) =>
  (value: string, additionalProps: any) => ({
    ...RULES[ruleType][0](value, additionalProps),
    ...options
  });
